import { render, staticRenderFns } from "./RecipientsPage.vue?vue&type=template&id=e92fad02&scoped=true&"
var script = {}
import style0 from "./RecipientsPage.vue?vue&type=style&index=0&id=e92fad02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92fad02",
  null
  
)

export default component.exports